import React from 'react';

/**
 * Componente de prueba para verificar que TailwindCSS está funcionando correctamente
 */
const TailwindTest: React.FC = () => {
  return (
    <div className="p-8 max-w-md mx-auto">
      <div className="bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg shadow-lg p-6 text-white">
        <h2 className="text-2xl font-bold mb-4">🎨 TailwindCSS Instalado</h2>
        <p className="text-sm mb-4">
          Si ves este componente con estilos correctos, TailwindCSS está
          funcionando perfectamente.
        </p>
        <div className="flex gap-2">
          <button className="bg-gray-100 text-blue-600 px-4 py-2 rounded-md font-semibold hover:bg-gray-100 transition-colors">
            Botón 1
          </button>
          <button className="bg-yellow-400 text-gray-900 px-4 py-2 rounded-md font-semibold hover:bg-yellow-300 transition-colors">
            Botón 2
          </button>
        </div>
      </div>

      <div className="mt-6 grid grid-cols-3 gap-4">
        <div className="bg-red-500 h-20 rounded-lg"></div>
        <div className="bg-green-500 h-20 rounded-lg"></div>
        <div className="bg-blue-500 h-20 rounded-lg"></div>
      </div>
    </div>
  );
};

export default TailwindTest;
